import type { Report } from '@/data-sources/contract';
import { reports } from '../engine/reports';

const clone = (report: (typeof reports)[number]): Report => {
  const { campaign, ...base } = report;
  return {
    ...base,
    authorBadge: 'gray',
    widgets: report.widgets.map((widget) => ({ ...widget })),
    ...(campaign
      ? {
          campaign: {
            ...campaign,
            keywords: [...campaign.keywords],
            postIds: [...campaign.postIds],
            urls: campaign.urls ? [...campaign.urls] : undefined,
          },
        }
      : {}),
  };
};

export const reportsDb: { reports: Report[]; revision: number } = {
  reports: reports.map(clone),
  revision: 0,
};
export function resetReportsDb(): void {
  reportsDb.reports = reports.map(clone);
  reportsDb.revision = 0;
}
